function cleanupTinymceContent(html) {
  html.querySelectorAll("[data-shortcode-remove-onclick]").forEach(e => e.parentNode.removeChild(e));
  html.querySelectorAll(".dash-highlight").forEach(element => {
    element.classList.remove("dash-highlight");
  });
}

export { cleanupTinymceContent };
